import { PillTheme } from "@redotech/redo-model/pill-theme";
import classNames from "classnames";
import { memo } from "react";
import {
  RedoBadge,
  RedoBadgeColor,
  RedoBadgeSize,
} from "../arbiter-components/badge/redo-badge";
import XIcon from "../icon-old/x.svg";
import * as tagInputCss from "./tag-input.module.css";

interface TagLike {
  name: string;
  pillTheme: PillTheme;
}

export const TagPillThemes = [
  PillTheme.NORMAL,
  PillTheme.PRIMARY_LIGHT,
  PillTheme.LIGHT_PINK,
  PillTheme.DANGER,
  PillTheme.NEUTRAL_YELLOW,
  PillTheme.SUCCESS,
  PillTheme.NEUTRAL_BLUE,
  PillTheme.SOLID_RED,
  PillTheme.SOLID_LIGHT_BLUE,
  PillTheme.SOLID_NAVY,
];

export const BadgePillThemeToColorMapping: Record<PillTheme, RedoBadgeColor> = {
  [PillTheme.NORMAL]: "gray",
  [PillTheme.PRIMARY_LIGHT]: "purple",
  [PillTheme.LIGHT_PINK]: "pink",
  [PillTheme.DANGER]: "orange",
  [PillTheme.NEUTRAL_YELLOW]: "warning",
  [PillTheme.SUCCESS]: "success",
  [PillTheme.NEUTRAL_BLUE]: "blueLight",
  [PillTheme.PRIMARY]: "purple",
  [PillTheme.SOLID_PINK]: "pink",
  [PillTheme.SOLID_RED]: "error",
  [PillTheme.SOLID_ORANGE]: "orange",
  [PillTheme.SOLID_YELLOW]: "warning",
  [PillTheme.SOLID_GREEN]: "success",
  [PillTheme.SOLID_LIGHT_BLUE]: "blue",
  [PillTheme.SOLID_NAVY]: "indigo",
  [PillTheme.SOLID_BLACK]: "black",
  [PillTheme.SOLID_WHITE]: "white",
};

export const TagPill = memo(function TagPill({
  tag,
  xClicked,
  showOverflow = false,
  badgeSize = "sm",
}: {
  tag: TagLike;
  xClicked?(): void;
  showOverflow?: boolean;
  badgeSize?: RedoBadgeSize;
}) {
  return (
    <div
      className={classNames(
        tagInputCss.pillWrapper,
        showOverflow && tagInputCss.showOverflow,
      )}
    >
      <RedoBadge
        color={BadgePillThemeToColorMapping[tag.pillTheme]}
        iconTrailing={
          xClicked
            ? { type: "icon", onClick: xClicked, Icon: XIcon }
            : undefined
        }
        size={badgeSize}
        text={tag.name}
      />
    </div>
  );
});
